import {Component, ContentChild, ElementRef, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
  selector: 'exg-sectionpanel',
  templateUrl: './exg-sectionpanel.component.html',
  styles: [
  ]
})
export class ExgSectionpanelComponent implements OnInit {

  @ContentChild('content') content?: TemplateRef<ElementRef>;
  @ContentChild('hiddencontent') hiddencontent?: TemplateRef<ElementRef>;
  @Input() caption!: string;


  id = Math.random().toString(36).substring(2);
  showPanel = false;

  constructor() { }

  ngOnInit(): void {
  }
  onClick(): void{
    this.showPanel = !this.showPanel;
  }
}
